<footer class="footer">
      <div id="userEmail" style="display: none;">{{email}}</div>
    <span>Copyright © {{currentYear}} Merck & Co., Inc., Rahway, NJ, USA and its affiliates. All rights reserved.</span>
    <span class="footerSpan">V&I Search Navigator</span>
</footer>